import { tealiumEventParentGroupPrefix, MediaBitrate, MediaType, tealiumEventMediaGroupPrefix, StreamType, MediaAudioType, tealiumEventPageGroupPrefix, PlayerForm, tealiumEventPlayerGroupPrefix, PlayerCasting, tealiumEventExperimentGroupPrefix, tealiumEventBaseGroupPrefix, EventPageSection, playerStateManager, TealiumEventNames, TealiumEventCategory, PlayerStatus, HeartbeatIntervals, HeartbeatLabels, HeartbeatEvents, VolumeEventLabel, AdActions, PlayerEvents } from '@4tn/core-audio-player-shared';
const trackLink = eventData => {
  var _a;
  const utag = window.utag || {};
  (_a = utag == null ? void 0 : utag.link) == null ? void 0 : _a.call(utag, eventData);
};
function convertUtcToUnix(utcTime) {
  return Date.parse(utcTime) / 1e3;
}
function firstInOrder(items, item) {
  const itemIndex = items.indexOf(item);
  if (itemIndex !== -1) {
    items.splice(itemIndex, 1);
    items.unshift(item);
  }
}
class TealiumEventParent {
  constructor() {
    this.parent_hostname = document.referrer || document.location.hostname;
  }
  getEventGroupProps() {
    const groupKeys = Object.keys(this).filter(k => k.startsWith(tealiumEventParentGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, {
      [k]: this[k]
    }), {});
    return eventGroupProps;
  }
}
class TealiumEventMedia {
  constructor(_ref) {
    let {
      mediaBitrate,
      mediaDatepublished,
      mediaDuration,
      mediaGenre,
      mediaId,
      mediaName,
      mediaOffset,
      mediaProgramEpisodenumber,
      mediaProgramName,
      mediaProgramSeason,
      mediaQuality,
      mediaType,
      mediaAudiotype,
      mediaMetaDescription,
      mediaStationname,
      mediaThumbnail,
      mediaSize,
      mediaVideotype
    } = _ref;
    this.media_bitrate = MediaBitrate["64KBPS"];
    this.media_datepublished = null;
    this.media_duration = 0;
    this.media_genre = null;
    this.media_id = "";
    this.media_name = null;
    this.media_offset = null;
    this.media_program_episodenumber = null;
    this.media_program_name = null;
    this.media_program_season = null;
    this.media_quality = null;
    this.media_type = MediaType.AUDIO;
    this.media_audiotype = null;
    this.media_meta_description = null;
    this.media_stationname = null;
    this.media_thumbnail = null;
    this.media_size = null;
    this.media_videotype = null;
    if (mediaBitrate) {
      this.media_bitrate = mediaBitrate;
    }
    if (mediaDatepublished) {
      this.media_datepublished = mediaDatepublished;
    }
    if (mediaDuration) {
      this.media_duration = mediaDuration;
    }
    if (mediaGenre) {
      this.media_genre = mediaGenre;
    }
    if (mediaId) {
      this.media_id = mediaId;
    }
    if (mediaName) {
      this.media_name = mediaName;
    }
    if (mediaOffset) {
      this.media_offset = Math.floor(mediaOffset);
    }
    if (mediaProgramEpisodenumber) {
      this.media_program_episodenumber = mediaProgramEpisodenumber;
    }
    if (mediaQuality) {
      this.media_quality = mediaQuality;
    }
    if (mediaProgramSeason) {
      this.media_program_season = mediaProgramSeason;
    }
    if (mediaProgramName) {
      this.media_program_name = mediaProgramName;
    }
    if (mediaType) {
      this.media_type = mediaType;
    }
    if (mediaAudiotype) {
      this.media_audiotype = mediaAudiotype;
    }
    if (mediaMetaDescription) {
      this.media_meta_description = mediaMetaDescription;
    }
    if (mediaStationname) {
      this.media_stationname = mediaStationname;
    }
    if (mediaThumbnail) {
      this.media_thumbnail = mediaThumbnail;
    }
    if (mediaSize) {
      this.media_size = mediaSize;
    }
    if (mediaVideotype) {
      this.media_videotype = mediaVideotype;
    }
  }
  static parseMediaPublished(mediaDatepublished) {
    return convertUtcToUnix(mediaDatepublished);
  }
  getEventGroupProps() {
    const groupKeys = Object.keys(this).filter(k => k.startsWith(tealiumEventMediaGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, {
      [k]: this[k]
    }), {});
    return eventGroupProps;
  }
  parseMediaMetadata(mediaMetadata) {
    var _a;
    const {
      publishDate,
      durationSeconds,
      id,
      title,
      podcastTitle,
      episode,
      contentTypeId,
      season,
      description,
      slug,
      images
    } = mediaMetadata;
    if (id) {
      this.media_id = id;
    }
    if (podcastTitle || title) {
      this.media_name = podcastTitle || title;
    }
    if (publishDate) {
      this.media_datepublished = TealiumEventMedia.parseMediaPublished(publishDate);
    }
    this.media_duration = durationSeconds || 0;
    if (episode) {
      this.media_program_episodenumber = episode;
    }
    if (contentTypeId && contentTypeId === StreamType.PODCAST) {
      this.media_program_name = title || null;
    }
    if (season) {
      this.media_program_season = season;
    }
    this.media_audiotype = contentTypeId === StreamType.STATION ? MediaAudioType.RADIO_LIVE : MediaAudioType.PODCAST;
    if (description) {
      this.media_meta_description = description;
    }
    if (slug) {
      this.media_stationname = slug;
    }
    if (images) {
      this.media_thumbnail = ((_a = images[0]) == null ? void 0 : _a.uri) || null;
    }
  }
  validateMediaOffset(mediaMetadata) {
    if (mediaMetadata.contentTypeId === StreamType.STATION) {
      this.media_offset = null;
    }
  }
}
class TealiumEventPage {
  constructor(_ref2) {
    let {
      pageCategory
    } = _ref2;
    this.page_category = null;
    this.page_host = document.referrer || document.location.hostname;
    if (pageCategory) {
      this.page_category = pageCategory;
    }
  }
  getEventGroupProps() {
    const groupKeys = Object.keys(this).filter(k => k.startsWith(tealiumEventPageGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, {
      [k]: this[k]
    }), {});
    return eventGroupProps;
  }
}
class TealiumEventPlayer {
  constructor(_ref3) {
    let {
      playerAutoplay,
      playerChannel,
      playerChannelid,
      playerFullscreen,
      playerWidth,
      playerHeight,
      playerId,
      playerState,
      playerVersion,
      playerForm
    } = _ref3;
    this.player_autoplay = false;
    this.player_casting = TealiumEventPlayer.detectCasting();
    this.player_channel = null;
    this.player_channelid = null;
    this.player_embedurl = window == null ? void 0 : window.location.href;
    this.player_fullscreen = false;
    this.player_width = null;
    this.player_height = null;
    this.player_id = null;
    this.player_state = null;
    this.player_engine = "html";
    this.player_version = null;
    this.player_form = PlayerForm.NORMAL_PLAYER;
    if (playerAutoplay) {
      this.player_autoplay = playerAutoplay;
    }
    if (playerChannel) {
      this.player_channel = playerChannel;
    }
    if (playerChannelid) {
      this.player_channelid = playerChannelid;
    }
    if (playerFullscreen) {
      this.player_fullscreen = playerFullscreen;
    }
    if (playerWidth) {
      this.player_width = playerWidth;
    }
    if (playerHeight) {
      this.player_height = playerHeight;
    }
    if (playerId) {
      this.player_id = playerId;
    }
    if (playerState) {
      this.player_state = playerState;
    }
    if (playerVersion) {
      this.player_version = playerVersion;
    }
    if (playerForm) {
      this.player_form = playerForm;
    }
  }
  getEventGroupProps() {
    const groupKeys = Object.keys(this).filter(k => k.startsWith(tealiumEventPlayerGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, {
      [k]: this[k]
    }), {});
    return eventGroupProps;
  }
  static detectCasting() {
    const castDevices = ["crkey", "apple tv", "tv", "avhttp", "heos", "carplay"];
    const userAgent = navigator.userAgent.toLowerCase();
    for (let i = 0; i < castDevices.length; i++) {
      if (userAgent.indexOf(castDevices[i]) !== -1) {
        switch (castDevices[i]) {
          case castDevices[0]:
            return PlayerCasting.CHROMECAST;
          case castDevices[1]:
            return PlayerCasting.AIRPLAY;
          case castDevices[3]:
            return PlayerCasting.AIRPLAY;
          case castDevices[4]:
            return PlayerCasting.HEOS;
          case castDevices[5]:
            return PlayerCasting.CARPLAY;
          default:
            return true;
        }
      }
    }
    return false;
  }
  parseMediaMetadata(mediaMetadata) {
    var _a;
    const {
      title,
      slug,
      media
    } = mediaMetadata;
    this.player_channel = title || slug || null;
    if (media) {
      this.player_channelid = ((_a = media[0]) == null ? void 0 : _a.uri) || null;
    }
  }
}
class TealiumEventExperiment {
  constructor(_ref4) {
    let {
      experimentTests,
      experimentTestVariant,
      experimentFeatures
    } = _ref4;
    this.experiment_tests = null;
    this.experiment_test_variant = null;
    this.experiment_features = null;
    if (experimentTests) {
      this.experiment_tests = experimentTests;
    }
    if (experimentTestVariant) {
      this.experiment_test_variant = experimentTestVariant;
    }
    if (experimentFeatures) {
      this.experiment_features = experimentFeatures;
    }
  }
  getEventGroupProps() {
    const groupKeys = Object.keys(this).filter(k => k.startsWith(tealiumEventExperimentGroupPrefix));
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, {
      [k]: this[k]
    }), {});
    return eventGroupProps;
  }
}
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) for (var prop of __getOwnPropSymbols$1(b)) {
    if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  }
  return a;
};
class TealiumEvent {
  constructor(_ref5) {
    let {
      eventName,
      eventCategory,
      eventLabel,
      eventValue,
      eventPageSection,
      media,
      page,
      player,
      experiment,
      mediaMetadata
    } = _ref5;
    this.event_label = null;
    this.event_value = null;
    this.event_page_section = null;
    this.event_name = eventName;
    this.event_category = eventCategory;
    if (eventLabel) {
      this.event_label = eventLabel;
    }
    if (eventValue) {
      this.event_value = eventValue;
    }
    if (eventPageSection) {
      this.event_page_section = eventPageSection;
    }
    this.parent = new TealiumEventParent();
    this.media = new TealiumEventMedia(media || {});
    this.page = new TealiumEventPage(page || {});
    this.player = new TealiumEventPlayer(player || {});
    this.experiment = new TealiumEventExperiment(experiment || {});
    if (mediaMetadata) {
      this.media.parseMediaMetadata(mediaMetadata);
      this.player.parseMediaMetadata(mediaMetadata);
      this.media.validateMediaOffset(mediaMetadata);
    }
  }
  getEventGroupProps() {
    const groupKeys = Object.keys(this).filter(k => k.startsWith(tealiumEventBaseGroupPrefix));
    firstInOrder(groupKeys, "event_category");
    firstInOrder(groupKeys, "event_name");
    const eventGroupProps = groupKeys.reduce((o, k) => Object.assign(o, {
      [k]: this[k]
    }), {});
    return eventGroupProps;
  }
  getEventData() {
    var _a, _b, _c, _d, _e;
    return __spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1(__spreadValues$1({}, this.getEventGroupProps()), (_a = this.parent) == null ? void 0 : _a.getEventGroupProps()), (_b = this.media) == null ? void 0 : _b.getEventGroupProps()), (_c = this.page) == null ? void 0 : _c.getEventGroupProps()), (_d = this.player) == null ? void 0 : _d.getEventGroupProps()), (_e = this.experiment) == null ? void 0 : _e.getEventGroupProps());
  }
  omitEventProps(omitKeys) {
    const eventProps = this.getEventData();
    if (omitKeys.length > 0) {
      const filteredKeys = Object.keys(eventProps).filter(k => omitKeys.includes(k));
      const filteredProps = filteredKeys.reduce((o, k) => Object.assign(o, {
        [k]: this[k]
      }), {});
      return filteredProps;
    }
    return eventProps;
  }
  static getPageSection(element) {
    const elementRect = element.getBoundingClientRect();
    const position = (window == null ? void 0 : window.pageYOffset) || document.documentElement.scrollTop;
    if (elementRect.top < ((window == null ? void 0 : window.innerHeight) || document.documentElement.clientHeight) + position) {
      return EventPageSection.ABOVE_THE_FOLD;
    }
    return EventPageSection.BELOW_THE_FOLD;
  }
}
const streamStartTealiumEventHandler = () => {
  const {
    trackStreamStart,
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  if (trackStreamStart) {
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_START,
      eventCategory: TealiumEventCategory.PLAYER,
      player: {
        playerState: PlayerStatus.START,
        playerVersion
      },
      mediaMetadata
    });
    trackLink(tealiumEvent.getEventData());
  }
};
const streamResumedTealiumEventHandler = event => {
  if (event.contentType === StreamType.PODCAST) {
    const {
      mediaMetadata,
      playerVersion
    } = playerStateManager.getState();
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_RESUME,
      eventCategory: TealiumEventCategory.PLAYER,
      media: {
        mediaOffset: event.time
      },
      player: {
        playerState: PlayerStatus.RESUME,
        playerVersion
      },
      mediaMetadata
    });
    trackLink(tealiumEvent.getEventData());
  }
};
const streamStopTealiumEventHandler = event => {
  var _a, _b;
  const {
    playerVersion
  } = playerStateManager.getState();
  const mediaMetadata = event.media.getStreamSource();
  if (((_a = event == null ? void 0 : event.media) == null ? void 0 : _a.contentType) === StreamType.STATION) {
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_STOP,
      eventCategory: TealiumEventCategory.PLAYER,
      player: {
        playerState: PlayerStatus.STOP,
        playerVersion
      },
      mediaMetadata
    });
    trackLink(tealiumEvent.getEventData());
  } else if (((_b = event.media) == null ? void 0 : _b.contentType) === StreamType.PODCAST) {
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_PAUSE,
      eventCategory: TealiumEventCategory.PLAYER,
      media: {
        mediaOffset: event.time
      },
      player: {
        playerState: PlayerStatus.PAUSE,
        playerVersion
      },
      mediaMetadata
    });
    trackLink(tealiumEvent.getEventData());
  }
};
const streamPauseTealiumEventHandler = event => {
  var _a;
  if (((_a = event.media) == null ? void 0 : _a.contentType) === StreamType.PODCAST) {
    const {
      playerVersion
    } = playerStateManager.getState();
    const mediaMetadata = event.media.getStreamSource();
    const tealiumEvent = new TealiumEvent({
      eventName: TealiumEventNames.PLAYER_PAUSE,
      eventCategory: TealiumEventCategory.PLAYER,
      media: {
        mediaOffset: event.time
      },
      player: {
        playerState: PlayerStatus.PAUSE,
        playerVersion
      },
      mediaMetadata
    });
    trackLink(tealiumEvent.getEventData());
  }
};
const streamSwitchTealiumEventHandler = event => {
  var _a;
  const {
    playerVersion
  } = playerStateManager.getState();
  const mediaMetadata = event.media.getStreamSource();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_SWITCH,
    eventCategory: TealiumEventCategory.PLAYER,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: ((_a = event == null ? void 0 : event.media) == null ? void 0 : _a.contentType) === StreamType.STATION ? PlayerStatus.STOP : PlayerStatus.PAUSE,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
let timeoutId;
let currentTime;
const INITIAL_HEARTBEAT_STATE = {
  timeout: HeartbeatIntervals.ONE_MINUTE,
  startTimestamp: 0,
  stopTimestamp: 0,
  eventLabel: HeartbeatLabels.LABEL_1,
  elapsedTime: 0,
  resetCounter: false
};
const getInitialHeartbeatState = () => __spreadValues({}, INITIAL_HEARTBEAT_STATE);
const heartbeatState = getInitialHeartbeatState();
const updateHeartbeatState = (newTimeout, label) => {
  heartbeatState.startTimestamp = Date.now();
  heartbeatState.timeout = newTimeout;
  heartbeatState.eventLabel = label;
  heartbeatState.elapsedTime = 0;
};
const playerState = {
  contentId: ""
};
const updateCurrentTime = time => {
  currentTime = Math.floor(time);
};
const startCounter = (media, trackLink, wasConnectionLost) => {
  const reset = heartbeatState.resetCounter || (heartbeatState.stopTimestamp ? Date.now() - heartbeatState.stopTimestamp > HeartbeatIntervals.FORTYFIVE_MINUTES : false);
  if (!wasConnectionLost && (media == null ? void 0 : media.contentId) !== playerState.contentId || reset) {
    Object.assign(heartbeatState, getInitialHeartbeatState());
    clearTimeout(timeoutId);
  }
  if (!wasConnectionLost) {
    playerState.contentId = media == null ? void 0 : media.contentId;
  }
  const sendEvent = (timeout2, label) => {
    updateHeartbeatState(timeout2, label);
    timeoutId = setTimeout(() => {
      const {
        mediaMetadata,
        playerVersion
      } = playerStateManager.getState();
      const tealiumEvent = new TealiumEvent({
        eventName: TealiumEventNames.PLAYER_HEARTBEAT,
        eventCategory: TealiumEventCategory.PLAYER,
        eventLabel: heartbeatState.eventLabel,
        media: {
          mediaOffset: currentTime || 0
        },
        player: {
          playerState: PlayerStatus.PLAY,
          playerVersion
        },
        mediaMetadata
      });
      trackLink(tealiumEvent.getEventData());
      switch (heartbeatState.eventLabel) {
        case HeartbeatLabels.LABEL_1:
          sendEvent(HeartbeatIntervals.SEVEN_MINUTES, HeartbeatLabels.LABEL_8);
          break;
        case HeartbeatLabels.LABEL_8:
          sendEvent(HeartbeatIntervals.SEVEN_MINUTES, HeartbeatLabels.LABEL_15);
          break;
        default:
          heartbeatState.eventLabel += HeartbeatLabels.LABEL_15;
          sendEvent(HeartbeatIntervals.FIFTEEN_MINUTES, heartbeatState.eventLabel);
          break;
      }
    }, timeout2);
  };
  heartbeatState.elapsedTime += heartbeatState.stopTimestamp - heartbeatState.startTimestamp;
  const timeout = heartbeatState.timeout - heartbeatState.elapsedTime;
  heartbeatState.startTimestamp = Date.now();
  sendEvent(timeout, heartbeatState.eventLabel);
};
const stopCounter = () => {
  heartbeatState.stopTimestamp = Date.now();
  clearTimeout(timeoutId);
};
const resetCounter = () => {
  heartbeatState.resetCounter = true;
  clearTimeout(timeoutId);
};
const streamHeartBeatTealiumEventHandler = event => {
  const {
    name,
    media,
    time
  } = event;
  switch (name) {
    case HeartbeatEvents.START_HEARTBEAT:
      startCounter(media, trackLink, false);
      break;
    case HeartbeatEvents.STOP_HEARTBEAT:
      stopCounter();
      break;
    case HeartbeatEvents.RESET_HEARTBEAT:
      resetCounter();
      break;
    case HeartbeatEvents.UPDATE_TIME:
      updateCurrentTime(time);
      break;
  }
};
const playerReconnectTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_RECONNECT,
    eventCategory: TealiumEventCategory.PLAYER,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: (mediaMetadata == null ? void 0 : mediaMetadata.contentTypeId) === StreamType.STATION ? PlayerStatus.STOP : PlayerStatus.PAUSE,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const streamEndedTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_COMPLETE,
    eventCategory: TealiumEventCategory.PLAYER,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: PlayerStatus.END,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const streamErrorTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_ERROR,
    eventCategory: TealiumEventCategory.PLAYER,
    eventLabel: event.name,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: PlayerStatus.ERROR,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const streamMutedTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_VOLUME,
    eventCategory: TealiumEventCategory.PLAYER,
    eventLabel: VolumeEventLabel.MUTE,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: PlayerStatus.MUTE,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const streamUnmutedTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_VOLUME,
    eventCategory: TealiumEventCategory.PLAYER,
    eventLabel: VolumeEventLabel.UNMUTE,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: PlayerStatus.UNMUTE,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const streamMuteStopTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_STOP,
    eventCategory: TealiumEventCategory.PLAYER,
    eventLabel: VolumeEventLabel.MUTE,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: PlayerStatus.MUTE,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const streamUnmuteStartTealiumEventHandler = event => {
  const {
    mediaMetadata,
    playerVersion
  } = playerStateManager.getState();
  const tealiumEvent = new TealiumEvent({
    eventName: TealiumEventNames.PLAYER_PLAY,
    eventCategory: TealiumEventCategory.PLAYER,
    eventLabel: VolumeEventLabel.UNMUTE,
    media: {
      mediaOffset: event.time
    },
    player: {
      playerState: PlayerStatus.UNMUTE,
      playerVersion
    },
    mediaMetadata
  });
  trackLink(tealiumEvent.getEventData());
};
const configureUTag = eventDispatcher => {
  eventDispatcher.on(AdActions.AD_START, () => {});
  eventDispatcher.on(AdActions.AD_BLOCKER_DETECTED, () => {});
  eventDispatcher.on(AdActions.AD_STOP, () => {});
  eventDispatcher.on(PlayerEvents.STREAM_START, streamStartTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_RESUMED, streamResumedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_STOP, streamStopTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_SWITCH, streamSwitchTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_PAUSE, streamPauseTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_ENDED, streamEndedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_MUTED, streamMutedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_UNMUTED, streamUnmutedTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_MUTE_STOP, streamMuteStopTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_UNMUTE_START, streamUnmuteStartTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_ERROR, streamErrorTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.STREAM_STATUS, () => {});
  eventDispatcher.on(PlayerEvents.STREAM_FAIL, () => {});
  eventDispatcher.on(PlayerEvents.HEARTBEAT, streamHeartBeatTealiumEventHandler);
  eventDispatcher.on(PlayerEvents.TRACK_CUE_POINT, () => {});
  eventDispatcher.on(PlayerEvents.PLAYER_RECONNECT, playerReconnectTealiumEventHandler);
  return () => {
    eventDispatcher.removeListener(AdActions.AD_START, () => {});
    eventDispatcher.removeListener(AdActions.AD_BLOCKER_DETECTED, () => {});
    eventDispatcher.removeListener(AdActions.AD_STOP, () => {});
    eventDispatcher.removeListener(PlayerEvents.STREAM_START, streamStartTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_RESUMED, streamResumedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_STOP, streamStopTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_SWITCH, streamSwitchTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_PAUSE, streamPauseTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_ENDED, streamEndedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_MUTED, streamMutedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_UNMUTED, streamUnmutedTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_MUTE_STOP, streamMuteStopTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_UNMUTE_START, streamUnmuteStartTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_ERROR, streamErrorTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.STREAM_STATUS, () => {});
    eventDispatcher.removeListener(PlayerEvents.STREAM_FAIL, () => {});
    eventDispatcher.removeListener(PlayerEvents.HEARTBEAT, streamHeartBeatTealiumEventHandler);
    eventDispatcher.removeListener(PlayerEvents.TRACK_CUE_POINT, () => {});
    eventDispatcher.removeListener(PlayerEvents.PLAYER_RECONNECT, playerReconnectTealiumEventHandler);
  };
};
const init = () => {
  return "core-audio-player-analytics -> init";
};
export { TealiumEvent, configureUTag, init, trackLink };